import { GlIcon, GlIntersperse, GlFilteredSearchSuggestion, GlLabel } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { isScopedLabel } from '~/lib/utils/common_utils';
import { stripQuotes } from '~/lib/utils/text_utility';
import { __ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { OPTIONS_NONE_ANY } from '../constants';
import BaseToken from './base_token.vue?vue3';
export default {
    name: 'LabelToken',
    components: {
        BaseToken,
        GlIcon,
        GlFilteredSearchSuggestion,
        GlIntersperse,
        GlLabel
    },
    mixins: [
        glListenersMixin
    ],
    inject: [
        'hasScopedLabelsFeature'
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            labels: this.config.initialLabels || [],
            allLabels: this.config.initialLabels || [],
            loading: false
        };
    },
    computed: {
        defaultLabels () {
            return this.config.defaultLabels || OPTIONS_NONE_ANY;
        }
    },
    methods: {
        getActiveLabel (labels, data) {
            return labels.find((label)=>this.getLabelName(label) === stripQuotes(data));
        },
        findLabelByName (name) {
            return this.allLabels.find((label)=>this.getLabelName(label) === name);
        },
        findLabelById (id) {
            return this.allLabels.find((label)=>label.id === id);
        },
        showScopedLabel (labelName) {
            const label = this.findLabelByName(labelName);
            return isScopedLabel(label) && this.hasScopedLabelsFeature;
        },
        getLabelBackgroundColor (labelName) {
            const label = this.findLabelByName(labelName);
            const backgroundColor = label?.color || '#fff0';
            return backgroundColor;
        },
        /**
     * There's an inconsistency between private and public API
     * for labels where label name is included in a different
     * property;
     *
     * Private API => `label.title`
     * Public API => `label.name`
     *
     * This method allows compatibility as there may be instances
     * where `config.fetchLabels` provided externally may still be
     * using either of the two APIs.
     */ getLabelName (label) {
            return label.name || label.title;
        },
        updateListOfAllLabels () {
            const dedupedLabels = this.dedupeLabels(this.labels);
            dedupedLabels.forEach((label)=>{
                if (!this.findLabelById(label.id)) {
                    this.allLabels.push(label);
                }
            });
        },
        fetchLabels (searchTerm) {
            this.loading = true;
            this.config.fetchLabels(searchTerm).then((res)=>{
                // We'd want to avoid doing this check but
                // labels.json and /groups/:id/labels & /projects/:id/labels
                // return response differently.
                const rawLabels = Array.isArray(res) ? res : res.data;
                this.labels = this.dedupeLabels(rawLabels);
                this.updateListOfAllLabels();
                if (this.config.fetchLatestLabels) {
                    this.fetchLatestLabels(searchTerm);
                }
            }).catch(()=>createAlert({
                    message: __('There was a problem fetching labels.')
                })).finally(()=>{
                this.loading = false;
            });
        },
        fetchLatestLabels (searchTerm) {
            this.config.fetchLatestLabels(searchTerm).then((res)=>{
                // We'd want to avoid doing this check but
                // labels.json and /groups/:id/labels & /projects/:id/labels
                // return response differently.
                const rawLabels = Array.isArray(res) ? res : res.data;
                this.labels = this.dedupeLabels(rawLabels);
                this.updateListOfAllLabels();
            }).catch(()=>createAlert({
                    message: __('There was a problem fetching latest labels.')
                }));
        },
        dedupeLabels (labels) {
            const seen = new Set();
            return labels.filter((label)=>{
                const labelName = this.getLabelName(label);
                if (seen.has(labelName)) {
                    return false;
                }
                seen.add(labelName);
                return true;
            });
        }
    }
};
